var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriveHighway(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.04 57.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "37.89 23.87 37.89 28.86 44.55 28.86 44.55 28.39 41.2 23.87 37.89 23.87",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.88,37.19h-3.39c-.41,2.87-2.87,5-5.77,5s-5.36-2.13-5.77-5h-8.44c-.45,3.18-3.41,5.4-6.59,4.95-2.56-.36-4.58-2.38-4.95-4.95h-1.72V17.21c0-.92,.75-1.67,1.66-1.67h23.3c.92,0,1.67,.75,1.67,1.67v3.33h4.99l4.99,6.75v9.9ZM28.52,0C12.77,0,0,12.77,0,28.52s12.77,28.52,28.52,28.52c15.74-.02,28.5-12.78,28.52-28.52C57.04,12.77,44.27,0,28.52,0",
    style: {
      fill: "#c42032"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveHighway);
export default __webpack_public_path__ + "static/media/DriveHighway.8c0f5d354f54b71f9f8406fcf130ef43.svg";
export { ForwardRef as ReactComponent };